import { useState, useEffect, useCallback } from 'react';

const useValidation = (formValues, validate, apiRequest, nextStep, code) => {
    const [form, setForm] = useState(formValues);
    const [errors, setErrors] = useState({});
    const [submitForm, setSubmitForm] = useState(false);

    const makeRequest = useCallback(async () => {
        try {
            await apiRequest(form, code);
            return nextStep();
        } catch (error) {
            if (error.response.data?.message.includes('first_name') || error.response.data?.message.includes('last_name')) {
                setErrors({
                    message: 'First Name and Last Name are required fields'
                });
            } else {
                setErrors({
                    message: error?.response?.data?.message
                });
            }
        }
        setSubmitForm(false);
    }, [apiRequest, code, form, nextStep]);
    useEffect(() => {
        if (submitForm) {
            makeRequest();
        }
    }, [makeRequest, submitForm]);

    const handleChange = e => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const userSubmit = e => {
        e.preventDefault();
        const validateForm = validate(form);
        if (Object.keys(validateForm).length === 0) {
            setSubmitForm(true);
        }
        setErrors(validateForm);
    };

    const resetForm = () => {
        setForm(formValues);
    };

    return {
        form,
        errors,
        handleChange,
        userSubmit,
        submitForm,
        resetForm
    };
};

export default useValidation;
